(function ($) {
  if (!$) return;

  var FORM_SELECTOR =
    'form.js-card-add-to-cart[data-type="add-to-cart-form"], form.js-card-add-to-cart';
  var PRODUCT_FORM_SELECTOR = 'product-form[data-product-id]';

  function formatPrice(cents) {
    if (cents === undefined || cents === null || cents === '') return '';
    var n = Number(cents);
    if (Number.isNaN(n)) return '';
    return '€' + (n / 100).toFixed(2).replace('.', ',');
  }

  function decodeHtmlEntities(str) {
    if (!str || typeof str !== 'string') return str;
    return str
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .trim();
  }

  function getProductVariants($productForm) {
    var pid = $productForm.attr('data-product-id');
    if (pid && window.productVariantsData && window.productVariantsData[pid]) {
      return window.productVariantsData[pid];
    }

    var raw = $productForm.attr('data-variants');
    if (!raw) return null;

    raw = decodeHtmlEntities(raw);

    try {
      return JSON.parse(raw);
    } catch (e) {
      console.error('[VariantFix] Invalid variants JSON', e, raw);
      return null;
    }
  }

  function findHiddenIdInput($productForm) {
    var $hidden = $productForm.find('input[name="id"]').first();
    if ($hidden.length) return $hidden;
    return $productForm.find('form').find('input[name="id"]').first();
  }

  function setHiddenVariantId($productForm, variantId) {
    var $hidden = findHiddenIdInput($productForm);
    if ($hidden && $hidden.length) $hidden.val(String(variantId));
  }

  /* ✅ IMPORTANT: Scope by `.price` FIRST, not `.price__container`
     Because unit-price blocks may be siblings of product-form but still inside `.price`.
  */
  function getPriceScope($productForm) {
    var $scope = $productForm.closest('.price');
    if ($scope.length) return $scope;

    $scope = $productForm.closest('.price__container');
    if ($scope.length) return $scope;

    return $productForm.closest('.card__information, .card-wrapper, .grid__item').first();
  }

  function setCardPriceAndAttrs($productForm, variantId, formattedPrice) {
    var $scope = getPriceScope($productForm);
    if (!$scope.length) return;

    var $productSelect = $scope.find('.product-select').first();
    if ($productSelect.length) {
      $productSelect
        .attr('data-variant-id', variantId)
        .attr('data-price', formattedPrice)
        .attr('data-price-formatted', formattedPrice);
    }

    // Update ONLY within this scope
    $scope
      .find('.price__container .price-item.price-item--regular, .price-item.price-item--regular')
      .first()
      .text(formattedPrice);
  }

  function setButtonStockState($productForm, available) {
    var $btn = $productForm
      .find('button[name="add"], button[type="submit"][name="add"]')
      .first();
    if (!$btn.length) return;

    var $inStock = $btn.find('.in-stock-custom');
    var $outStock = $btn.find('.out-stock-custom');

    if ($inStock.length && $outStock.length) {
      if (available) {
        $inStock.removeClass('hidden');
        $outStock.addClass('hidden');
        $btn.prop('disabled', false);
      } else {
        $inStock.addClass('hidden');
        $outStock.removeClass('hidden');
        $btn.prop('disabled', true);
      }
    }
  }

  /* ✅ UNIT PRICE FIX (correct scope + correct span picking) */
  function setUnitPriceOutput($productForm, variantObj) {
    var $scope = getPriceScope($productForm);
    if (!$scope.length) return;

    var $units = $scope.find('small.unit-price-text, small.unit-price-hidden');
    if (!$units.length) return;

    // Hide if no unit price
    if (
      !variantObj ||
      variantObj.unit_price === undefined ||
      variantObj.unit_price === null ||
      !variantObj.unit_price_measurement
    ) {
      $units.addClass('hidden');
      return;
    }

    var meas = variantObj.unit_price_measurement || {};
    var refVal = meas.reference_value || 1;
    var refUnit = meas.reference_unit || '';

    var unitPriceText = formatPrice(variantObj.unit_price);
    var refText = (refVal !== 1 ? (refVal + ' ') : '') + refUnit;

    $units.each(function () {
      var $u = $(this);
      var $last = $u.find('.price-item.price-item--last').first();
      if (!$last.length) return;

      // Find the unit-price number span:
      // first span child (NOT aria-hidden, NOT visually-hidden)
      var $unitSpan = $last.children('span').filter(function () {
        var $s = $(this);
        if ($s.attr('aria-hidden') === 'true') return false;
        if ($s.hasClass('visually-hidden')) return false;
        return true;
      }).first();

      // Find the reference span:
      // last span child (NOT aria-hidden, NOT visually-hidden)
      var $refSpan = $last.children('span').filter(function () {
        var $s = $(this);
        if ($s.attr('aria-hidden') === 'true') return false;
        if ($s.hasClass('visually-hidden')) return false;
        return true;
      }).last();

      if ($unitSpan.length) $unitSpan.text(unitPriceText);
      if ($refSpan.length) $refSpan.text(refText);
    });

    $units.removeClass('hidden');
  }

  function getSelectedOptionsByIndex($productForm, variants) {
    var optionLen =
      (variants && variants[0] && variants[0].options && variants[0].options.length)
        ? variants[0].options.length
        : 0;

    var selectedByIndex = new Array(optionLen);

    $productForm.find('.variant-option:checked').each(function () {
      var $el = $(this);
      if ($el.hasClass('bundle-variant-option')) return;

      var idx = $el.data('option-index');
      if (idx === undefined || idx === null || idx === '') return;
      selectedByIndex[Number(idx)] = $el.val();
    });

    return selectedByIndex;
  }

  function hasAllOptionsSelected(arr) {
    if (!arr || !arr.length) return false;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === undefined) return false;
    }
    return true;
  }

  function updateSelectedVariant($productForm) {
    if (!$productForm || !$productForm.length) return;

    var variants = getProductVariants($productForm);

    /* (1) BUNDLE MODE */
    var $bundleChecked = $productForm.find('.bundle-variant-option:checked');
    if ($bundleChecked.length) {
      var variantId = Number($bundleChecked.val());
      var cents = $bundleChecked.attr('data-price-cents');
      var available = String($bundleChecked.attr('data-available')) === 'true';
      var formattedPrice = formatPrice(cents);

      setHiddenVariantId($productForm, variantId);
      setCardPriceAndAttrs($productForm, variantId, formattedPrice);
      setButtonStockState($productForm, available);

      var hasUnit = String($bundleChecked.attr('data-has-unit')) === 'true';
      if (!hasUnit) {
        setUnitPriceOutput($productForm, null);
        return;
      }

      var unitCents = $bundleChecked.attr('data-unit-price-cents');
      var refVal = Number($bundleChecked.attr('data-unit-ref-value') || 1);
      var refUnit = $bundleChecked.attr('data-unit-ref-unit') || '';

      var pseudoVariant = {
        unit_price: unitCents ? Number(unitCents) : null,
        unit_price_measurement: { reference_value: refVal, reference_unit: refUnit }
      };

      setUnitPriceOutput($productForm, pseudoVariant);
      return;
    }

    /* (2) NORMAL MODE */
    if (!variants || !variants.length) return;

    var selectedOptions = getSelectedOptionsByIndex($productForm, variants);
    if (!hasAllOptionsSelected(selectedOptions)) return;

    var matchedVariant = variants.find(function (v) {
      if (!v.options || v.options.length !== selectedOptions.length) return false;
      for (var i = 0; i < v.options.length; i++) {
        if (v.options[i] !== selectedOptions[i]) return false;
      }
      return true;
    });

    if (!matchedVariant) return;

    setHiddenVariantId($productForm, matchedVariant.id);

    var formatted = formatPrice(matchedVariant.price);
    setCardPriceAndAttrs($productForm, matchedVariant.id, formatted);
    setButtonStockState($productForm, !!matchedVariant.available);
    setUnitPriceOutput($productForm, matchedVariant);
  }

  function initAllCards() {
    $(PRODUCT_FORM_SELECTOR).each(function () {
      var $pf = $(this);

      // Default-check first radio for EACH option index (normal mode only)
      if (!$pf.find('.bundle-variant-option').length) {
        var idxMap = {};
        $pf.find('.variant-option[data-option-index]').each(function () {
          var $el = $(this);
          if ($el.hasClass('bundle-variant-option')) return;
          var idx = $el.data('option-index');
          if (idx === undefined || idx === null || idx === '') return;
          idxMap[String(idx)] = true;
        });

        Object.keys(idxMap).forEach(function (idxStr) {
          var idx = Number(idxStr);
          var sel = '.variant-option[data-option-index="' + idx + '"]';
          if (!$pf.find(sel + ':checked').length) {
            $pf.find(sel).first().prop('checked', true);
          }
        });
      }

      updateSelectedVariant($pf);
    });
  }

  function bindVariantChange() {
    $(document).off('change.variantFix', '.variant-option');
    $(document).on('change.variantFix', '.variant-option', function () {
      var $pf = $(this).closest(PRODUCT_FORM_SELECTOR);
      if (!$pf.length) return;
      updateSelectedVariant($pf);
    });
  }

  function bindBundleToggleClick() {
    $(document).off('click.bundleToggleFix', PRODUCT_FORM_SELECTOR + ' .switch-wrapper');
    $(document).on('click.bundleToggleFix', PRODUCT_FORM_SELECTOR + ' .switch-wrapper', function (e) {
      var $wrap = $(this);
      var $bundleRadios = $wrap.find('input.bundle-variant-option[type="radio"]');
      if (!$bundleRadios.length) return;

      if ($(e.target).is('input[type="radio"]')) return;

      e.preventDefault();
      e.stopPropagation();

      if ($bundleRadios.length !== 2) return;

      var $checked = $bundleRadios.filter(':checked');
      var $next = $checked.length ? $bundleRadios.not($checked) : $bundleRadios.first();

      $next.prop('checked', true);
      $next.trigger('change');

      var el = $next.get(0);
      if (el) el.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function bindNormalToggleSwitch() {
    $(document).off('click.normalToggleSwitch', PRODUCT_FORM_SELECTOR + ' .option-group.is-toggle-option .switch-wrapper');

    $(document).on('click.normalToggleSwitch', PRODUCT_FORM_SELECTOR + ' .option-group.is-toggle-option .switch-wrapper', function (e) {
      if ($(e.target).is('input[type="radio"]')) return;

      var $wrap = $(this);
      if ($wrap.find('input.bundle-variant-option[type="radio"]').length) return;

      var $radios = $wrap.find('input.variant-option[type="radio"]');
      if ($radios.length !== 2) return;

      e.preventDefault();

      var $checked = $radios.filter(':checked');
      var $next = $checked.length ? $radios.not($checked) : $radios.first();

      $next.prop('checked', true);
      $next.trigger('change');

      var el = $next.get(0);
      if (el) el.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }



   function bindAjaxATC() {
    $(document).off('submit.cardATC', FORM_SELECTOR);

    $(document).on('submit.cardATC', FORM_SELECTOR, function (e) {
      var $form = $(this);

      if ($form.data('submitting')) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      var $pf = $form.closest(PRODUCT_FORM_SELECTOR);
      if ($pf.length) updateSelectedVariant($pf);

      var formEl = $form.get(0);
      if (!formEl) return;

      var formData = new FormData(formEl);
      var id = formData.get('id');

      if (!id && $pf.length) {
        var $hidden = findHiddenIdInput($pf);
        if ($hidden.length) id = $hidden.val();
        if (id) formData.set('id', id);
      }

      if (!id) return;

      $form.data('submitting', true);

      var $btn = $form.find('[type="submit"]').first();
      $btn.prop('disabled', true).addClass('loading');

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function () {
          var url = new URL(window.location.href);
          url.searchParams.set('open_cart_n', '2');
          window.location.href = url.toString();
        },
        complete: function () {
          $form.data('submitting', false);
          $btn.prop('disabled', false).removeClass('loading');
        }
      });
    });
  }


  

  function bindBundleIconUI() {
    $(document).off('click.bundleIconShow', 'label.variant-btn.case_one_bottle.no-text-case');
    $(document).on('click.bundleIconShow', 'label.variant-btn.case_one_bottle.no-text-case', function () {
      $(this).closest('.price__container').find('.bundles-number').show();
    });

    $(document).off('click.bundleIconHide', 'label.variant-btn.case_one.no-text-case');
    $(document).on('click.bundleIconHide', 'label.variant-btn.case_one.no-text-case', function () {
      $(this).closest('.price__container').find('.bundles-number').hide();
    });
  }

  $(document).ready(function () {
    initAllCards();
    bindVariantChange();
    bindBundleToggleClick();
    bindNormalToggleSwitch();
    bindAjaxATC();
    bindBundleIconUI();
  });

})(window.jQuery);
